import * as types from '@/store/mutations-types.js'

const state = {
  updateLogDialog: false
}

const action = {}

const mutations = {
  [types.UPDATE_LOG_DIALOG] (state, updateLogDialog) {
    state.updateLogDialog = updateLogDialog
  }
}

export default {
  state,
  action,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/help/update-log.js